import Tabs from '@web/components/Tabs'
import { motion } from 'framer-motion'

export default function ClientsSection() {
  const clients = [
    {
      tab: 'Government',
      clients: [
        { name: 'Buller District Council', src: 'buller' },
        { name: 'Christchurch City Council', src: 'christchurch' },
        { name: 'Climate Change Commission', src: 'cc_commission' },
        { name: 'Vanuatu Government', src: 'vanuatu' },
        { name: 'Emergency Management Canterbury', src: 'cdem' },
        { name: 'European Union', src: 'eu' },
        { name: 'Far North District Council', src: 'farnorth' },
        { name: 'GGGI', src: 'gggi' },
        { name: 'Gisborne District Council', src: 'gisborne' },
        { name: 'Hamilton City Council', src: 'hamilton' },
        { name: "Hawke's Bay Regional Council", src: 'hawkesbay' },
        { name: 'Horizons Regional Council', src: 'horizons' },
        { name: 'Nelson', src: 'nelson' },
        { name: 'Northland Regional Council', src: 'northland' },
        { name: 'Tasmania', src: 'tasmania' },
        { name: 'Thames–Coromandel District Council', src: 'tcdc' },
        { name: 'Waikato', src: 'waikato' },
        { name: 'Waimakariri District Council', src: 'waimakariri' },
        { name: 'Wellington City Council', src: 'wellington' },
        { name: 'Whangarei District Council', src: 'whangarei' },
        { name: 'WREMO', src: 'wremo' },
      ],
    },
    {
      tab: 'Infrastructure',
      clients: [
        { name: 'Aurora Energy', src: 'aurora' },
        { name: 'Electra', src: 'electra' },
        { name: 'Foodstuffs', src: 'foodstuffs' },
        { name: 'Fulton Hogan', src: 'fulton_hogan' },
        { name: "Hawke's Bay Airport", src: 'hawkesbay_airport' },
        { name: 'MainPower', src: 'mainpower' },
        { name: 'Mr Apple', src: 'mrapple' },
        { name: 'Orion', src: 'orion' },
        { name: 'Scales', src: 'scales' },
        { name: 'Unison', src: 'unison' },
        { name: 'Wellington Electricity', src: 'wellington_electricity' },
      ],
    },
    {
      tab: 'Property and Land Use',
      clients: [
        { name: 'Community Housing Aotearoa', src: 'cha' },
        { name: 'NHS', src: 'nhs' },
      ],
    },
  ]
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="flex mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start gap-8 w-full">
          <h1 className="text-4xl leading-tight font-light text-brand-blue">
            Our clients across sectors
          </h1>
          <Tabs
            items={clients.map((client) => ({
              label: client.tab,
              content: (
                <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5 py-8 min-h-[200px]">
                  {client.clients.map((c, idx) => (
                    <motion.div
                      key={c.name}
                      className="flex items-start justify-center py-1 px-1 min-h-16"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: (idx * 0.2) / client.clients.length, duration: 0.4 }}
                    >
                      <img
                        src={`./website/logos/${c.src}.jpg`}
                        alt={c.name}
                        title={c.name}
                        className="w-full max-w-[200px] h-16 object-contain"
                      />
                    </motion.div>
                  ))}
                </div>
              ),
            }))}
          />
        </div>
      </div>
    </section>
  )
}
